var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"上传组件"}},[_c('PluginUpload')],1),_c('el-tab-pane',{attrs:{"label":"富文本编辑"}},[_c('PluginEditor')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }